import React from "react";

const ProgressStatus = ({ progress, progressMessage, status }) => (
  <div className={`progress-status progress-status--${status}`}>
    <progress max="100" value={progress}>
      {progress}%
    </progress>
    <span>{progressMessage}</span>
  </div>
);

export default ProgressStatus;
